import PropTypes from "prop-types";
import React from "react";
import AppConstants from "../constants/AppConstants";
import SidePanelButton from "./SidePanelButton";
import styles from "./SidePanel.module.css";

const PROPERTY_PANEL_CONTAINER_WIDTH = "16.5625rem";

class SidePanel extends React.Component {
  static propTypes = {
    open: PropTypes.bool,
    width: PropTypes.string,
    position: PropTypes.oneOf(["left", "right"]),
  };

  static defaultProps = {
    width: AppConstants.PANEL_WIDTH_OPEN,
    open: true,
  };

  handleBtnClick = (e) => {
    if (this.props.toggle) {
      this.props.toggle(e);
    }
  };

  render() {
    let { width, id } = this.props;

    width = this.props.position === "right" ? PROPERTY_PANEL_CONTAINER_WIDTH : width;
    if (!this.props.open) {
      width = AppConstants.PANEL_WIDTH_CLOSED;
    }

    const style = {
      width,
    };

    let leftComponent = null;
    let rightComponent = null;

    if (this.props.position === "right") {
      leftComponent = (
        <SidePanelButton
          onClick={this.handleBtnClick}
          open={this.props.open}
          openIcon="icon-arrow-right"
          closeIcon="icon-arrow-left"
        />
      );
      if (this.props.open) {
        rightComponent = this.props.children;
      }
    } else {
      if (this.props.open) {
        leftComponent = this.props.children;
      }
      rightComponent = (
        <SidePanelButton
          onClick={this.handleBtnClick}
          open={this.props.open}
          openIcon="icon-arrow-left"
          closeIcon="icon-arrow-right"
        />
      );
    }

    return (
      <div id={id} style={style} className={styles["side-panel"]}>
        {leftComponent}
        {rightComponent}
      </div>
    );
  }
}

export default SidePanel;
